/**
 * AS: American Samoa
 * GU: Guam
 * MP: Northern Mariana Islands
 * PR: Puerto Rico
 * VI: U.S. Virgin Islands
 * https://en.wikipedia.org/wiki/Territories_of_the_United_States
 */

export const UNITED_STATES = 'US'
export const CANADA = 'CA'
export const DEFAULT_REGION = UNITED_STATES

// TODO: Verify if the guild promotion regions are correct. Throughout the code we are checking isUnitedStates most of the time.
// In some places, we are checking broadly for DOMESTIC_REGIONS, which includes Canada and territories of the US.
// In other places, we are checking for US or CA. Need to make sure our region checks are consistent and correct.
export const UNITED_STATES_AND_TERRITORIES = ['US', 'AS', 'GU', 'MP', 'PR', 'VI']
export const DOMESTIC_REGIONS = [...UNITED_STATES_AND_TERRITORIES, CANADA]
export const ENGLISH_SPEAKING_REGIONS = ['AU', 'CA', 'IE', 'NZ', 'GB', 'US', 'UK']

export const AUSTRALIA = 'AU'
